import { Database, Q } from '@nozbe/watermelondb'

import { Chat } from '../model'

export const findChatByConnectionKeyAndPhoneNumber = async (
  connectionKey: string,
  phoneNumber: string,
  database: Database
): Promise<Chat | undefined> => {
  try {
    const chats = database.collections.get<Chat>('chats')
    return await database.read(async () => {
      const fetchChats = await chats
        .query(Q.and(Q.where('connection_key', Q.eq(connectionKey)), Q.where('phone_number', Q.eq(phoneNumber))))
        .fetch()
      if (fetchChats.length) return fetchChats[0]
      return undefined
    })
  } catch (e) {
    console.error(e)
  }
}
